import Skeleton from "react-loading-skeleton";

export function AddendumRejectionBannerSkeleton() {
  return (
    <div className="tw:flex tw:h-[130px] tw:flex-col tw:justify-center tw:gap-3.5 tw:rounded-lg tw:border tw:border-stroke-quaternary tw:px-3 tw:py-2.5">
      <Skeleton height={20} width={180} />
      <div className="tw:flex tw:flex-col tw:gap-2">
        <Skeleton height={16} width="60%" />
        <Skeleton height={16} width="75%" />
      </div>
    </div>
  );
}
